/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    StationOrLocationAutocompleteFilter,
    StationOrLocationAutocompleteFilterFromJSON,
    StationOrLocationAutocompleteFilterToJSON,
    StationOrLocationItemAutocompleteResult,
    StationOrLocationItemAutocompleteResultFromJSON,
    StationOrLocationItemAutocompleteResultToJSON,
} from '../models';

export interface ApiStationLocationAutocompletePostRequest {
    stationOrLocationAutocompleteFilter?: StationOrLocationAutocompleteFilter;
}

/**
 * no description
 */
export class StationLocationAutocompleteApi extends runtime.BaseAPI {

    /**
     */
    async apiStationLocationAutocompletePostRaw(requestParameters: ApiStationLocationAutocompletePostRequest): Promise<runtime.ApiResponse<StationOrLocationItemAutocompleteResult>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/StationLocationAutocomplete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationOrLocationAutocompleteFilterToJSON(requestParameters.stationOrLocationAutocompleteFilter),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => StationOrLocationItemAutocompleteResultFromJSON(jsonValue));
    }

    /**
     */
    async apiStationLocationAutocompletePost(requestParameters: ApiStationLocationAutocompletePostRequest): Promise<StationOrLocationItemAutocompleteResult> {
        const response = await this.apiStationLocationAutocompletePostRaw(requestParameters);
        return await response.value();
    }

}
